export const media = {
  logo:
    'https://res.cloudinary.com/dcjxlbq4z/image/upload/v1612836816/abhelections/ABH_Logo_mel2e1.jpg',
};
